import {
  IconCircleInfo,
  Button,
  SimpleModal,
  GreyGrey80,
  IndigoIndigo10,
  IndigoIndigo20,
  IndigoIndigo50,
  Primary13SemiBold,
  Primary13Regular,
  Box,
  Flex,
  Grid
} from '@sequencehq/core-components'
import { BillingPeriodPill } from './ScheduleTimelineDataSeries/BillingPeriodPill'

const titleTextStyle = {
  ...Primary13SemiBold,
  color: GreyGrey80
}
const descriptionTextStyle = {
  ...Primary13Regular,
  color: GreyGrey80
}
const pillTheme = {
  border: IndigoIndigo50,
  progressFill: IndigoIndigo20,
  upcomingFill: IndigoIndigo10
}

const LegendSection = (props: { title: string; children: React.ReactNode }) => {
  return (
    <Box>
      <Box {...titleTextStyle} marginBottom="16px">
        {props.title}
      </Box>
      <Box>{props.children}</Box>
    </Box>
  )
}

const ScheduleTimelineLegendModal = (props: {
  trigger: React.ReactElement
}) => {
  return (
    <SimpleModal
      trigger={props.trigger}
      title="Legend"
      data-testid="scheduleTimelineLegend"
      submitButtonText="Done"
      showCancelButton={false}
      onSubmit={() => true}
    >
      <Flex flexDirection="column" gap="24px" userSelect="none">
        <LegendSection title="Recurring prices">
          <Grid
            gridTemplateColumns="auto 1fr"
            gridRowGap="12px"
            gridColumnGap={'16px'}
            gridTemplateRows="auto"
          >
            <BillingPeriodPill theme={pillTheme} width={74} />
            <Box>In arrears</Box>
            <BillingPeriodPill theme={pillTheme} width={74} isInAdvance />
            <Box>In advance</Box>
            <BillingPeriodPill theme={pillTheme} width={74} isMinimum />
            <Box>Minimum</Box>
            <BillingPeriodPill theme={pillTheme} width={74} isProrated />
            <Box>Prorated</Box>
            <BillingPeriodPill
              theme={pillTheme}
              width={74}
              openEndedFillWidth={74}
            />
            <Box>Ongoing / Milestone</Box>
          </Grid>
        </LegendSection>
        <LegendSection title="One time prices">
          <Grid
            gridTemplateColumns="auto 1fr"
            gridRowGap="12px"
            gridColumnGap={'16px'}
            gridTemplateRows="auto"
          >
            <BillingPeriodPill theme={pillTheme} width={74} isOneTime />
            <Box>In arrears</Box>
            <BillingPeriodPill
              theme={pillTheme}
              width={74}
              isOneTime
              isInAdvance
            />
            <Box>In advance</Box>
          </Grid>
        </LegendSection>
      </Flex>
    </SimpleModal>
  )
}

export const ScheduleTimelineLegend = () => {
  return (
    <ScheduleTimelineLegendModal
      trigger={
        <Button
          variant="ghost"
          icon={<IconCircleInfo color={GreyGrey80} />}
          aria-label="timeline-legend"
          data-testid="scheduleTimelineLegend.trigger"
        />
      }
    />
  )
}
